import { render, staticRenderFns } from "./BaTraderBidWanted.vue?vue&type=template&id=200cd3e0&scoped=true&"
import script from "./BaTraderBidWanted.vue?vue&type=script&lang=js&"
export * from "./BaTraderBidWanted.vue?vue&type=script&lang=js&"
import style0 from "./BaTraderBidWanted.vue?vue&type=style&index=0&id=200cd3e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200cd3e0",
  null
  
)

export default component.exports